/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_Content_DescriptionInputs */

const en_subtitle_export_vchip_content_description = /** @type {(inputs: Subtitle_Export_Vchip_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content Description`)
};

const fr_subtitle_export_vchip_content_description = /** @type {(inputs: Subtitle_Export_Vchip_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description du contenu`)
};

const de_subtitle_export_vchip_content_description = /** @type {(inputs: Subtitle_Export_Vchip_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaltsbeschreibung`)
};

const it_subtitle_export_vchip_content_description = /** @type {(inputs: Subtitle_Export_Vchip_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione del contenuto`)
};

const ru_subtitle_export_vchip_content_description = /** @type {(inputs: Subtitle_Export_Vchip_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание содержимого`)
};

const es_subtitle_export_vchip_content_description = /** @type {(inputs: Subtitle_Export_Vchip_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción del contenido`)
};

const zh_cn2_subtitle_export_vchip_content_description = /** @type {(inputs: Subtitle_Export_Vchip_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容描述`)
};

const ja_subtitle_export_vchip_content_description = /** @type {(inputs: Subtitle_Export_Vchip_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンテンツの説明`)
};

const hi_subtitle_export_vchip_content_description = /** @type {(inputs: Subtitle_Export_Vchip_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामग्री का विवरण`)
};

const pt_pt2_subtitle_export_vchip_content_description = /** @type {(inputs: Subtitle_Export_Vchip_Content_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição do conteúdo`)
};

/**
* | output |
* | --- |
* | "Content Description" |
*
* @param {Subtitle_Export_Vchip_Content_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_content_description = /** @type {((inputs?: Subtitle_Export_Vchip_Content_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_Content_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_vchip_content_description(inputs)
	if (locale === "de") return de_subtitle_export_vchip_content_description(inputs)
	if (locale === "it") return it_subtitle_export_vchip_content_description(inputs)
	if (locale === "ru") return ru_subtitle_export_vchip_content_description(inputs)
	if (locale === "es") return es_subtitle_export_vchip_content_description(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_vchip_content_description(inputs)
	if (locale === "ja") return ja_subtitle_export_vchip_content_description(inputs)
	if (locale === "hi") return hi_subtitle_export_vchip_content_description(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_vchip_content_description(inputs)
	return en_subtitle_export_vchip_content_description(inputs)
});